module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG0d648939a8b66653ee5d7d755d4f2a23.0d648939.png";